var _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 24,
    viewBox: "0 0 106 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12L3 6.80382L11.9999 1.60767L21 6.80382L12.0001 12Z",
    fill: "url(#paint0_linear_132_1383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 17.1953L12 22.3914V11.9991L21.0001 6.80295V17.1953Z",
    fill: "url(#paint1_linear_132_1383)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.3914L3 17.1953V6.80295L12.0001 11.9991V22.3914Z",
    fill: "url(#paint2_linear_132_1383)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.996 7.6L36.816 11.632L33.66 7.6H30.984V16H33.348V10.636L36.696 14.74H36.816L40.164 10.636V16H42.6V7.6H39.996ZM46.978 14.128V12.64H52.27V10.852H46.978V9.472H53.398V7.6H44.566V16H53.53V14.128H46.978ZM63.6234 7.6H54.2154V9.556H57.6834V16H60.1314V9.556H63.6234V7.6ZM71.2081 16H73.8121L69.4681 7.6H66.7921L62.4481 16H65.0161L65.8081 14.392H70.4161L71.2081 16ZM66.6481 12.652L68.1121 9.676L69.5641 12.652H66.6481ZM82.3138 7.6V12.736L77.3338 7.6H74.7418V16H77.1058V10.48L82.5298 16H84.6778V7.6H82.3138ZM89.0601 14.128V12.64H94.3521V10.852H89.0601V9.472H95.4801V7.6H86.6481V16H95.6121V14.128H89.0601ZM105.705 7.6H96.2975V9.556H99.7655V16H102.213V9.556H105.705V7.6Z",
    fill: "#050505"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_132_1383",
    x1: 21,
    y1: 1.60767,
    x2: 3,
    y2: 1.60767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_132_1383",
    x1: 17.5001,
    y1: 4.50052,
    x2: 14.5022,
    y2: 23.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_132_1383",
    x1: 13.4995,
    y1: 8.49956,
    x2: 0.999543,
    y2: 17.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c90794a3.svg";
export { ForwardRef as ReactComponent };